var _path, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPerspectives = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 61,
  viewBox: "0 0 60 61",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M45 23.103H50C51.3261 23.103 52.5978 23.6298 53.5355 24.5675C54.4732 25.5052 55 26.7769 55 28.103V55.603L45 45.603H30C28.6739 45.603 27.4021 45.0762 26.4645 44.1386C25.5268 43.2009 25 41.9291 25 40.603V38.103M35 23.103C35 24.4291 34.4732 25.7009 33.5355 26.6386C32.5978 27.5762 31.3261 28.103 30 28.103H15L5 38.103V10.603C5 7.85303 7.25 5.60303 10 5.60303H30C31.3261 5.60303 32.5978 6.12981 33.5355 7.06749C34.4732 8.00517 35 9.27694 35 10.603V23.103Z",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 14.375,
  cy: 16.853,
  r: 1.875,
  fill: "#30343C"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.625,
  cy: 16.853,
  r: 1.875,
  fill: "#30343C"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 26.875,
  cy: 16.853,
  r: 1.875,
  fill: "#30343C"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 38.75,
  cy: 34.353,
  r: 1.875,
  fill: "#30343C"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 34.353,
  r: 1.875,
  fill: "#30343C"
})));
export default SvgIconPerspectives;